import { render, staticRenderFns } from "./CustomerAssignDialog.vue?vue&type=template&id=cb91c114"
import script from "./CustomerAssignDialog.vue?vue&type=script&lang=js"
export * from "./CustomerAssignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports